class Usuario {
  static salvar($this, $form) {
    $('.preloader').show();

    $.ajax({
        type: 'POST',
        url: $form.prop('action'),
        data: $form.serialize()
      })
      .done(response => {
        Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            html: `O serviço foi salvo com sucesso.`,
          })
          .then(result => {
            if (result) {
              $('.preloader').show();
              window.location = response.url;
            }
          })
      })
      .fail(response => {

        let errorHTML = response.responseText;

        if (response.status === 412) {

          const errors = (response.responseJSON.errors);

          let messages = [];
          let $firstFocus = null;

          for (let error in errors) {
            if (!$firstFocus) {
              $firstFocus = $(`#${error}`);
            }
            $(`#${error}`).closest('.form-group').addClass('invalid-data');
            messages.push(`<li>${errors[error]}</li>`);
          }

          errorHTML = `
            Não foi possível salvar o usuário.
            <br>Verifique os campos em vermelho.
          `;
        }

        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: errorHTML,
        });
      })
      .always(() => {
        $('.preloader').hide();
      });
  }

  static listen() {
    jQuery(function () {

      $('input, select').closest('.form-group').addClass('focused');

      $(document).on('submit', '#formUsuario', function (e) {
        e.preventDefault();
        Usuario.salvar(this, $(this));
      });
    });
  }
}

export default Usuario;
